export default "__VITE_ASSET__Dt6h8MVo__"